import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    LinearProgress,
    MenuItem,
} from '@material-ui/core';
import { Field, FieldProps, Form, Formik } from 'formik';
import Spin from 'components/atoms/Spin/Spin';
import FormikTextField from '../../atoms/FormikInput/FormikInput';
import FormikSelectControl from '../../atoms/FormikSelect/FormicSelectControl';
import FormikDatePicker from '../../atoms/FormikDatePicker/FormikDatePicker';
import { useCourierLogic } from '../Couriers/useCourierLogic';
import { CourierInfo } from '../../molecules/CourierInfo';
import { CourierRegType } from '../../../api/couriers';

interface Props {
    type: CourierRegType;
}

const CourierConfirm = ({ type }: Props) => {
    const {
        loading,
        confirmLoading,
        handleOpenDialog,
        handleReject,
        handleBack,
        photos,
        request,
        classes,
        courierDataOpen,
        setCourierDataOpen,
        courierForm,
        courierDataFormValidScheme,
        handleConfirm,
        documentTypes,
    } = useCourierLogic(false);

    const user = request?.courier?.user;
    const courier = request?.courier;

    return (
        <Box className={classes.root}>
            <Button onClick={handleBack}>Назад</Button>

            {loading && <Spin variant="inline" />}
            {!loading && (
                <Box marginTop={3} marginLeft={1}>
                    <CourierInfo type={type} user={user} courier={courier} photos={photos} />
                    <Box className={classes.buttons}>
                        <div className={classes.progress}>
                            {confirmLoading && <LinearProgress />}
                        </div>
                        {type === CourierRegType.New && (
                            <>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={handleOpenDialog}
                                >
                                    Одобрить
                                </Button>
                                <Button
                                    color="secondary"
                                    variant="contained"
                                    onClick={handleReject}
                                >
                                    Отклонить
                                </Button>
                            </>
                        )}
                        {type === CourierRegType.Confirmed && (
                            <Button color="secondary" variant="contained" onClick={handleReject}>
                                Отклонить
                            </Button>
                        )}
                    </Box>
                </Box>
            )}
            <Dialog
                open={courierDataOpen}
                fullWidth={true}
                onClose={() => setCourierDataOpen(false)}
            >
                <Formik
                    enableReinitialize={true}
                    initialValues={courierForm.current}
                    validationSchema={courierDataFormValidScheme}
                    onSubmit={(values, { setSubmitting }) => {
                        handleConfirm(values, setSubmitting);
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <DialogTitle>Данные курьера</DialogTitle>
                            <DialogContent>
                                <Box display="flex" flexDirection="column">
                                    <Field name="document_type_id">
                                        {({ ...props }) => (
                                            <FormikSelectControl
                                                cls={classes.mt2}
                                                label="Вид документа"
                                                labelId="doc"
                                                {...props}
                                            >
                                                {documentTypes.map((doc, index) => (
                                                    <MenuItem key={index} value={doc.id}>
                                                        {doc.description}
                                                    </MenuItem>
                                                ))}
                                            </FormikSelectControl>
                                        )}
                                    </Field>
                                    <Field
                                        className={classes.mt2}
                                        component={FormikTextField}
                                        name="passport_number"
                                        label="Номер документа"
                                    />
                                    <Field name="passport_date">
                                        {({ ...props }: FieldProps) => (
                                            <FormikDatePicker
                                                className={classes.mt2}
                                                label="Дата выдачи"
                                                inputVariant="standard"
                                                clearable
                                                disableToolbar={false}
                                                {...props}
                                            />
                                        )}
                                    </Field>
                                    <Field
                                        className={classes.mt2}
                                        component={FormikTextField}
                                        name="passport_issued_by"
                                        label="Кем выдано"
                                    />
                                </Box>

                                {isSubmitting && <LinearProgress />}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setCourierDataOpen(false)}>Отмена</Button>
                                <Button type={'submit'}>Ок</Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </Box>
    );
};

export default CourierConfirm;
